@if (error(); as e) { <div class="alert alert-warning">{{ ('companion.errors.' + e) | translate }}</div> }

@if (profile(); as p) {
  <div class="cp-card">
    <h2 class="cp-h">{{ 'companion.settings.ai.title' | translate }}</h2>
    <p>{{ 'companion.settings.ai.text' | translate }}</p>
    <p class="mb-2"><span class="cp-chip" [class.cp-chip--ok]="p.ai_enabled" [class.cp-chip--warn]="!p.ai_enabled">{{ (p.ai_enabled ? 'companion.settings.ai.on' : 'companion.settings.ai.off') | translate }}</span>
      @if (!p.ai_enabled && p.ai_disabled_at) { <span class="cp-hint ms-1">{{ p.ai_disabled_at | date:'medium':undefined:lang() }}</span> }
    </p>
    @if (!readOnly()) {
      <button cButton [color]="p.ai_enabled ? 'secondary' : 'primary'" [variant]="p.ai_enabled ? 'outline' : undefined" [disabled]="busy()" (click)="setAi(!p.ai_enabled)">
        {{ (p.ai_enabled ? 'companion.settings.ai.switch_off' : 'companion.settings.ai.switch_on') | translate }}
      </button>
    }
  </div>
}

<div class="cp-card">
  <h2 class="cp-h">{{ 'companion.settings.documents.title' | translate }}</h2>
  @if (overview().documents.length) {
    <ul class="mb-1">
      @for (d of overview().documents; track d.id) {
        <li>{{ ('companion.settings.documents.kinds.' + d.kind) | translate }}: {{ d.title }} <span class="cp-hint">(v{{ d.version }}, {{ d.released_at | date:'mediumDate':undefined:lang() }})</span></li>
      }
    </ul>
  } @else {
    <p class="mb-1">{{ 'companion.settings.documents.none' | translate }}</p>
  }
  <p class="cp-hint mb-0">{{ 'companion.settings.documents.hint' | translate }}</p>
</div>

<div class="cp-card">
  <h2 class="cp-h">{{ 'companion.settings.export.title' | translate }}</h2>
  <p>{{ 'companion.settings.export.text' | translate }}</p>
  <div class="cp-actions">
    <button cButton color="secondary" variant="outline" (click)="export('json')">{{ 'companion.settings.export.json' | translate }}</button>
    <button cButton color="secondary" variant="outline" (click)="export('csv')">{{ 'companion.settings.export.csv' | translate }}</button>
  </div>
</div>

<div class="cp-card">
  <h2 class="cp-h">{{ 'companion.settings.safety.title' | translate }}</h2>
  <p>{{ 'companion.settings.safety.text' | translate }}</p>
  <p class="cp-hint">{{ 'companion.settings.safety.rules' | translate:{ version: overview().safety.rules_version } }}
    · {{ (overview().safety.reviewed ? 'companion.settings.safety.reviewed' : 'companion.settings.safety.not_reviewed') | translate }}</p>
  @if (overview().safety.help_contacts.length) {
    <ul class="mb-1">
      @for (c of overview().safety.help_contacts; track $index) { <li>{{ c.label }}: <strong>{{ c.number }}</strong> ({{ c.country }})</li> }
    </ul>
  } @else {
    <p class="cp-hint mb-1">{{ 'companion.settings.safety.no_contacts' | translate }}</p>
  }
  @if (overview().contact_email) {
    <p class="mb-0">{{ 'companion.settings.safety.contact' | translate }} <a [href]="'mailto:' + overview().contact_email">{{ overview().contact_email }}</a></p>
  }
</div>

@if (profile(); as p) {
  <div class="cp-card">
    <h2 class="cp-h">{{ 'companion.settings.consent.title' | translate }}</h2>
    <p class="cp-hint mb-0">{{ 'companion.settings.consent.text' | translate:{ version: p.consent_version || '—', date: (p.consented_at | date:'medium':undefined:lang()) || '—' } }}</p>
  </div>
}

@if (!readOnly() || profile()) {
  <div class="cp-card">
    <h2 class="cp-h">{{ 'companion.settings.delete.title' | translate }}</h2>
    <p>{{ 'companion.settings.delete.text' | translate }}</p>
    @if (deleted() !== null) { <p class="text-success">{{ 'companion.settings.delete.done' | translate }}</p> }
    <label class="cp-field"><span>{{ 'companion.settings.delete.confirm_label' | translate }}</span>
      <input class="form-control" type="text" style="max-width: 16rem" placeholder="DELETE" [ngModel]="deleteConfirm()" (ngModelChange)="deleteConfirm.set($event)" /></label>
    <button cButton color="danger" [disabled]="busy() || deleteConfirm() !== 'DELETE'" (click)="eraseAll()">{{ 'companion.settings.delete.button' | translate }}</button>
  </div>
}
